<template>
    <div>
        <el-dialog
           title="移动积分兑换冒险勋章"
           center
           :visible='exState'
           @close='closeModal'
           @open='getToken'
           width="500px"
           >
            <div>
                <el-form :model="ruleForm" :rules='rules' ref="ruleForm" label-position="right" label-width="120px">
                    <el-form-item label="手机号码" prop="tel" >
                        <el-input  v-model="ruleForm.tel"></el-input>
                    </el-form-item>
                    <el-form-item label="短信验证码" prop="code">
                        <el-input v-model.number="ruleForm.code" style='width: 150px;'></el-input>
                        <el-button type="primary" @click='getCode' :disabled='codeBtnName.flag'>{{codeBtnName.name}}</el-button>
                    </el-form-item>
                    <el-form-item style='margin-left: 50px;margin-top: 25px;'>
                        <el-button type="primary" @click="submitForm('ruleForm')" style='width: 100px;'>兑换</el-button>
                    </el-form-item>
                    <p class='font2'>注：请输入已发送短信兑换码的手机号码</p>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
  export default {
    name: "ExchangeModal",
    props: {
      exState: Boolean
    },
    data () {
      return {
        codeBtnName: {
          name: "发送验证码",
          num: 60,
          timer: null,
          flag: false
        },
        ruleForm: {
          tel: '',
          code: ''
        },
        rules: {
          tel: [
            { required: true, message: "请输入移动手机号", trigger: "blur"},
            { message: "只能是移动手机号码", pattern: /^((13[4-9])|(15([0-2]|[7-9]))|(18[2|3|4|7|8])|(178)|(147))[\d]{8}$/, trigger: "blur"}
          ],
          code: [
            { required: true, message: "请输入短信验证码", trigger: "blur"}
          ]
        },
        token: "",
      }
    },
    methods: {
      closeModal () {
        this.$emit('closeExchange',false);
        // 清空数据
        this.ruleForm.tel = "";
        this.ruleForm.code = "";
        // 关闭弹窗后还原状态
        this.codeBtnName.name = "发送验证码";
        this.codeBtnName.flag = false;
        clearInterval(this.codeBtnName.timer);  // 清除定时器
        this.codeBtnName.num = 60;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http.get('mm/consume',{
              params: {
                token: this.token,
                phone: this.ruleForm.tel,
                key: this.ruleForm.code
              }
            }).then(rel => {
              if (rel.data.code == 'OK') {
                // 绑定成功
                this.closeModal()
                this.$message({
                  message: '兑换成功，请点击查看我的勋章',
                  type: 'success'
                });
              }
            })
          }
        });
      },
      getCode() {
        this.$refs.ruleForm.validateField('tel',(err) => {
          // 如果手机号号为空
          if (!!err) {
            this.$message.error('请输入正确的手机号');
          }else {
            this.$http.get('mm/sendsms',{
              params: {
                token: this.token,
                phone: this.ruleForm.tel
              }
            }).then(rel => {
              if (rel.data.code == "OK") {
                this.codeBtnName.flag = true;
                this.codeBtnName.timer = setInterval(this.sendCode,1000)
                this.$message({
                  message: '发送成功，请查看手机短信',
                  type: 'success'
                });
              }else if (rel.data.code == 'FAILED') {
                this.$message({
                  message: "请先发送兑换指令，如果已经发送，请您稍后再试！",
                  type: 'warning'
                });
              }else if (rel.data.code == 'LEVELDB_NO_SUCH_DATA') {
                this.$message({
                  message: "请先绑定该手机号",
                  type: 'warning'
                });
              }
            }).catch(err => {
              console.log(err);
            })
          }
        })
      },
      sendCode () {
        this.codeBtnName.num--;
        if(this.codeBtnName.num >= 0 )
        {
          this.codeBtnName.name =  `还剩余${this.codeBtnName.num}秒`;
        }
        else
        {
          this.codeBtnName.name = "重新发送验证码";
          this.codeBtnName.flag = false;
          clearInterval(this.codeBtnName.timer);  // 清除定时器
          this.codeBtnName.num = 60;
        }
      },
      // 获取token
      getToken () {
        this.token = JSON.parse(window.sessionStorage.getItem('authinfo')).token;
      }
    }
  }
</script>

<style scoped>
    .font {
        color: rgb(153, 153, 153);;
    }
    .font2 {
        padding-left: 20px;
        color: #f00;
    }
</style>


// WEBPACK FOOTER //
// src/components/ExchangeModal.vue